import React, { FC } from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';
import FlexibleDatesRepricingMessage from './FlexibleDatesRepricingMessage';
import { useItinerary } from '../../Itinerary/Provider';
import { FlexibleDatesRepricingTrendType } from 'clientState/flexibleDatesDealHelper';

export enum FlexibleDatesRepricingMessagePositionType {
  insideCard = 'insideCard',
  belowCard = 'belowCard',
}

type FlexibleDatesRepricingMessageDecoratorType = {
  position: FlexibleDatesRepricingMessagePositionType;
};

type FlexibleDatesRepricingMessageDecoratorComponentType = {
  position: FlexibleDatesRepricingMessagePositionType;
  trend: FlexibleDatesRepricingTrendType;
};

const FlexibleDatesRepricingMessageDecoratorComponent: FC<
  FlexibleDatesRepricingMessageDecoratorComponentType
> = ({ position, trend, children }) => {
  return position === FlexibleDatesRepricingMessagePositionType.belowCard ? (
    <Box>
      <Box
        sx={{
          position: 'relative',
          zIndex: '2',
          boxShadow: '0 8px 8px rgba(0,0,0,0.03)',
          borderBottomLeftRadius: 'regular',
          borderBottomRightRadius: 'regular',
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          position: 'relative',
          marginTop: 'minus_1x_big',
          zIndex: '0',
          boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
          borderBottomLeftRadius: 'regular',
          borderBottomRightRadius: 'regular',
        }}
        width="100%"
      >
        <FlexibleDatesRepricingMessage trend={trend} position={position} />
      </Box>
    </Box>
  ) : (
    <FlexibleDatesRepricingMessage trend={trend} position={position} />
  );
};

const FlexibleDatesRepricingMessageDecorator: FC<
  FlexibleDatesRepricingMessageDecoratorType
> = ({ position, children }) => {
  const trend = useItinerary()?.flexibleDatesDealInfo?.trend;
  return trend ? (
    <FlexibleDatesRepricingMessageDecoratorComponent
      position={position}
      trend={trend}
    >
      {children}
    </FlexibleDatesRepricingMessageDecoratorComponent>
  ) : (
    <>{children}</>
  );
};

export default FlexibleDatesRepricingMessageDecorator;
